import {
    FETCH_MACHINES_REQUEST,
    FETCH_MACHINES_SUCCESS,
    FETCH_MACHINES_FAILURE,
    FETCH_MACHINE_REQUEST,
    FETCH_MACHINE_SUCCESS,
    FETCH_MACHINE_FAILURE,
    CREATE_MACHINE_REQUEST,
    CREATE_MACHINE_SUCCESS,
    CREATE_MACHINE_FAILURE,
    UPDATE_MACHINE_REQUEST,
    UPDATE_MACHINE_SUCCESS,
    UPDATE_MACHINE_FAILURE,
    DELETE_MACHINE_REQUEST,
    DELETE_MACHINE_SUCCESS,
    DELETE_MACHINE_FAILURE,
    ACTIVE_MACHINE_REQUEST,
    ACTIVE_MACHINE_SUCCESS,
    ACTIVE_MACHINE_FAILURE,
    FREE_MACHINES_REQUEST,
    FREE_MACHINES_SUCCESS,
    FREE_MACHINES_FAILURE,
  } from "./types";
  
  const initialState = {
    machines: [],
    machine: null,
    loading: false,
    error: "",
  };
  
  export function machineReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_MACHINES_REQUEST:
      case FETCH_MACHINE_REQUEST:
      case CREATE_MACHINE_REQUEST:
      case UPDATE_MACHINE_REQUEST:
      case DELETE_MACHINE_REQUEST:
      case ACTIVE_MACHINE_REQUEST:
      case FREE_MACHINES_REQUEST:
        return {
          ...state,
          loading: true,
          error: "",
        };
      case FETCH_MACHINES_SUCCESS:
        return {
          ...state,
          machines: action.payload,
          loading: false,
          error: "",
        };
      case FETCH_MACHINE_SUCCESS:
        return {
          ...state,
          machine: action.payload,
          loading: false,
          error: "",
        };
      case FREE_MACHINES_SUCCESS:
        return {
          ...state,
          machines: action.payload,
          loading: false,
          error: "",
        };
      case CREATE_MACHINE_SUCCESS:
        return {
          ...state,
          machines: [...state.machines, action.payload],
          loading: false,
          error: "",
        };
      case UPDATE_MACHINE_SUCCESS:
        return {
          ...state,
          machines: state.machines.map((machine) =>
            machine._id === action.payload._id ? action.payload : machine
          ),
          loading: false,
          error: "",
        };
      case DELETE_MACHINE_SUCCESS:
        return {
          ...state,
          machines: state.machines.filter(
            (machine) => machine._id !== action.payload
          ),
          loading: false,
          error: "",
        };
      case ACTIVE_MACHINE_SUCCESS:
        return {
          ...state,
          machines: state.machines.map((machine) =>
            machine._id === action.payload._id ? action.payload : machine
          ),
          loading: false,
          error: "",
        };
      case FETCH_MACHINES_FAILURE:
      case FETCH_MACHINE_FAILURE:
      case CREATE_MACHINE_FAILURE:
      case UPDATE_MACHINE_FAILURE:
      case DELETE_MACHINE_FAILURE:
      case ACTIVE_MACHINE_FAILURE:
      case FREE_MACHINES_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  }
  